import request from "@/utils/request";

// 获取首页数据
export const intelligentSecurity = (params) =>
  request({
    url: "/bigScreen/intelligentSecurity",
    method: "POST",
    data: params,
  });
// 获取视频
export const bigScreenVideo = (data) =>
  request({
    url: "/bigScreen/bigScreeVeido",
    headers: {
      "Content-Type": "application/json",
    },
    method: "POST",
    data: data,
  });
